import { render, staticRenderFns } from "./pam.vue?vue&type=template&id=058a564f&"
import script from "./pam.js?vue&type=script&lang=js&"
export * from "./pam.js?vue&type=script&lang=js&"
import style0 from "./pam.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports